import { faEnvelope } from "@fortawesome/free-regular-svg-icons"
import { faGlobe, faPhoneAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const SiteFooter = () => {
    return (
        <footer>
            <div className="footer-top">
                <img src="/logos/app-logo.png" alt="" className="footer-logo" />
                <div className="ft-text">
                    RW MOTORS brings you carefully selected, high quality used vehicles from China at the best value.
                </div>
            </div>
            <div className="footer-mid">
                <div className="mid-elem">
                    <div className="contact-box flx-cnt">
                        <span className="c-text cnt-label">CONTACT US</span>
                    </div>
                    <div className="cont-list">
                        <div className="list-unit">
                            <FontAwesomeIcon
                                className="unit-icon"
                                icon={faPhoneAlt}
                            />
                            <span className="unit-data">
                                +237678921882/+237640702678
                            </span>
                        </div>
                        <div className="list-unit">
                            <FontAwesomeIcon
                                className="unit-icon"
                                icon={faEnvelope}
                            />
                            <span className="unit-data">
                                rwautosales26@gmail.com
                            </span>
                        </div>
                        <div className="list-unit">
                            <FontAwesomeIcon
                                className="unit-icon"
                                icon={faGlobe}
                            />
                            <span className="unit-data">
                                rwmotors.randomwalktech.com
                            </span>
                        </div>
                        <div className="list-unit"></div>
                    </div>
                </div>
            </div>
        </footer>
    )
}